import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon, CheckIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
const proofPoints = ['Web a medida', 'Carta digital', 'Gestión incluida'];
const principles = [['01', 'Estrategia útil', 'Una estructura definida antes de diseñar.'], ['02', 'Diseño con intención', 'Cada sección facilita una decisión.'], ['03', 'Base preparada', 'Una presencia que puedes seguir cuidando.']];
export function Hero() {
  return <section className="border-b border-white/10 bg-[#0a0a0a] pt-24 sm:pt-28" data-id="element-41" data-mp="x9uqrn89208u">
      <div className="container mx-auto px-6 md:px-12" data-id="element-42" data-mp="sbb2vha3iedu">
        <motion.div initial={{
        opacity: 0,
        y: 18
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto max-w-6xl py-12 sm:py-16 lg:py-20" data-id="element-43" data-mp="s9q75oc1opee">
          <h1 className="max-w-4xl text-[2.5rem] font-medium leading-[1.02] tracking-[-0.055em] text-white sm:text-6xl sm:leading-[0.98] lg:text-7xl" data-id="element-44" data-mp="382ffxqfwf8fz">
            Tu negocio merece una presencia que esté a su altura.
          </h1>
          <div className="mt-8 grid gap-8 border-t border-white/10 pt-7 lg:grid-cols-[minmax(0,1fr)_minmax(220px,0.48fr)] lg:gap-14" data-id="element-45" data-mp="3o6kgnlhm6i6p">
            <div data-id="element-46" data-mp="39a38f34q1jod">
              <p className="max-w-2xl text-base leading-relaxed text-neutral-300 sm:text-lg" data-id="element-47" data-mp="39cpain8uf6z7">
                Diseñamos una base digital clara para que tus clientes entiendan
                tu valor, encuentren lo importante y sepan cómo avanzar.
              </p>
              <div className="mt-8 flex flex-col gap-3 sm:flex-row" data-id="element-48" data-mp="35aaueawk6lbm">
                <Link to="/checkout" className="button-primary group sm:min-w-[190px]" data-id="element-49" data-mp="2qkmthasahoof">
                  Iniciar mi proyecto
                  <ArrowRightIcon size={17} className="transition-transform duration-200 group-hover:translate-x-1" aria-hidden="true" data-id="element-50" data-mp="2vjg670zr5bnj" />
                </Link>
                <Link to="/proceso" className="button-secondary sm:min-w-[150px]" data-id="element-51" data-mp="s21hi9lxc9yx">
                  Ver el proceso
                </Link>
              </div>
            </div>
            <div className="border-l border-white/15 pl-5 sm:pl-6" data-id="element-52" data-mp="na0ab23m59fr">
              <p className="meta-label" data-id="element-53" data-mp="id9tudnwcbtt">Una propuesta, un objetivo</p>
              <p className="mt-4 text-sm leading-relaxed text-neutral-300" data-id="element-54" data-mp="ddf44dfuxsac">
                Ordenar tu mensaje, elevar la percepción de tu marca y facilitar
                la siguiente conversación.
              </p>
            </div>
          </div>
          <div className="mt-10 flex flex-wrap gap-x-5 gap-y-3 border-t border-white/10 pt-5" data-id="element-55" data-mp="162ccnou9oapw">
            {proofPoints.map(point => <span key={point} className="inline-flex items-center gap-2 text-xs font-medium text-neutral-300" data-id="element-56" data-mp="x14ldqq64a5b">
                <CheckIcon size={14} className="text-white" aria-hidden="true" data-id="element-57" data-mp="3lu9wv02xxwap" />
                {point}
              </span>)}
          </div>
        </motion.div>
      </div>

      <div className="border-t border-white/10 bg-black" data-id="element-58" data-mp="1xama741tsf59">
        <div className="container mx-auto grid max-w-6xl px-6 md:px-12 sm:grid-cols-3" data-id="element-59" data-mp="21amtp33s7gj6">
          {principles.map(([number, title, detail]) => <article key={number} className="border-b border-white/10 py-6 last:border-b-0 sm:border-b-0 sm:border-r sm:px-7 sm:first:pl-0 sm:last:border-r-0" data-id="element-60" data-mp="268g468c4awp9">
              <p className="meta-number" data-id="element-61" data-mp="2fzj2519r2vkb">{number}</p>
              <h2 className="mt-4 text-sm font-medium text-white" data-id="element-62" data-mp="2kydtirls9sg1">{title}</h2>
              <p className="mt-1.5 text-xs leading-relaxed text-neutral-400" data-id="element-63" data-mp="2p0h83p3r1d5j">
                {detail}
              </p>
            </article>)}
        </div>
      </div>
    </section>;
}